import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  @Input() autoFocusInput: boolean;
  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    setTimeout(() => {

      this.el.nativeElement.focus();

  }, 500);
  }


}
